var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconComments = function SvgIconComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.811 16.592a.44.44 0 0 1-.439-.44V14.28a.42.42 0 0 0-.422-.421H3.8c-.717 0-1.3-.584-1.3-1.3V4.714c0-.717.583-1.3 1.3-1.3h12.4c.717 0 1.3.583 1.3 1.3v7.845c0 .716-.583 1.3-1.3 1.3h-5.881c-.101 0-.199.036-.276.102l-2.946 2.525a.44.44 0 0 1-.286.106M4.055 4.487a.403.403 0 0 0-.408.397v7.374c0 .219.183.397.408.397h2.077c.693 0 1.256.548 1.256 1.222v.862l2.147-1.79a1.28 1.28 0 0 1 .818-.294h5.682a.4.4 0 0 0 .407-.397V4.884a.403.403 0 0 0-.407-.397z"
  })));
};
export default SvgIconComments;